/*eslint complexity: ["error", 40]*/
/*eslint max-lines-per-function: ["error", 340]*/
import React from 'react';
import { Form, Tab, Tabs } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import {
  CreateUpdateCardDto,
  GetExamDto,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import momencik from '../../../common/momencik';
import { SupportingExaminationView } from '../../containers/SupportingExaminationView/SupportingExaminationView';
import { SupportingType } from '../../../common/spdCore/validation/schemas';
import { RadioButtonWithDesc } from '../../../common/components/RadioButtonWithDesc';
import { FormControlTextarea3 } from '../../../app/components/FormControlTextarea';
import { ChooseSigned } from '../Users/ChooseSigned';
import { Role } from '../../../common/spdCore/authorization/roles';

import { CardStatusFields } from './CardStatusFields';
import { PhysicalMeasurementsFields } from './PhysicalMeasurementsFields';

interface CardDriverEditorProps {
  exam: GetExamDto;
  card: CreateUpdateCardDto;
  id: string | undefined;
  propertyChange: (obj: Partial<CreateUpdateCardDto>) => void;
  onSupportChange?: () => void;
}

export const CardDriverEditor: React.FC<CardDriverEditorProps> = ({
  exam,
  card,
  id,
  propertyChange,
  onSupportChange,
}) => {
  return (
    <>
      <Tabs defaultActiveKey="data" id="data" className="mb-2">
        <Tab eventKey="data" title="Dane podstawowe" className="mb-2">
          <div className="d-grid gap-3">
            <FormRow controlId="pass" label="Wynik pozytywny">
              <Form.Check
                type="checkbox"
                defaultChecked={
                  card?.pass || card?.pass === undefined || card?.pass === null
                    ? true
                    : false
                }
                onChange={e => propertyChange({ pass: e.target.checked })}
              />
            </FormRow>
            <FormRow controlId="staff" label="Lekarz">
              <ChooseSigned
                userUID={card?.psychologistUID}
                handleOnChange={user =>
                  propertyChange({
                    psychologistUID: user?.uid,
                  })
                }
                roles={[Role.MedicalAssessor, Role.MedicalSpecialist]}
              />
            </FormRow>
            <FormRow controlId="number" label="Numer">
              <Form.Control
                type="text"
                disabled={
                  card?.cardDate && card.cardDate.getFullYear() > 2024
                    ? true
                    : false
                }
                value={
                  id || (card?.cardDate && card.cardDate.getFullYear() <= 2024)
                    ? card?.number || ''
                    : '-- Numer zostanie nadany automatycznie po zapisie --'
                }
                onChange={e =>
                  propertyChange({
                    number: e.target.value,
                  })
                }
              />
            </FormRow>
            <FormRow controlId="cardDate" label="Data karty">
              <Form.Control
                type="date"
                name="datepic"
                required={false}
                placeholder="DateRange"
                value={momencik(card?.cardDate, 'YYYY-MM-DD')}
                onChange={e =>
                  propertyChange({
                    cardDate: e.target.value ? new Date(e.target.value) : null,
                  })
                }
              />
            </FormRow>
            <FormRow controlId="postDate" label="Data wysłania">
              <Form.Control
                type="date"
                name="datepic"
                required={false}
                placeholder="DateRange"
                value={momencik(card?.postDate, 'YYYY-MM-DD')}
                onChange={e =>
                  propertyChange({
                    postDate: e.target.value ? new Date(e.target.value) : null,
                  })
                }
              />
            </FormRow>
            <FormRow controlId="nextDate" label="Data następnego badania">
              <Form.Control
                type="date"
                name="datepic"
                placeholder="DateRange"
                value={momencik(card?.nextExamDate, 'YYYY-MM-DD')}
                onChange={e =>
                  propertyChange({ nextExamDate: new Date(e.target.value) })
                }
              />
            </FormRow>
            <FormRow controlId="justification" label="Rozpoznanie końcowe">
              <FormControlTextarea3
                defaultValue={card?.justification || ''}
                onChange={e =>
                  propertyChange({ justification: e.target.value })
                }
              />
            </FormRow>
            <FormRow controlId="conclusions" label="Zalecenia">
              <FormControlTextarea3
                defaultValue={card?.conclusions || ''}
                onChange={e => propertyChange({ conclusions: e.target.value })}
              />
            </FormRow>
            <FormRow
              controlId="examFrequencyChange"
              label="Zmiana częstotliwości wykonywania badań"
            >
              <Form.Check
                type="checkbox"
                defaultChecked={card?.examFrequencyChange ? true : false}
                onChange={e =>
                  propertyChange({ examFrequencyChange: e.target.checked })
                }
              />
            </FormRow>
            {card?.examFrequencyChange && (
              <FormRow
                controlId="examFrequencyChangeJustification"
                label="Uzasadnienie zmiany częstotliwości wykonywania badań"
              >
                <FormControlTextarea3
                  defaultValue={card?.examFrequencyChangeJustification || ''}
                  onChange={e =>
                    propertyChange({
                      examFrequencyChangeJustification: e.target.value,
                    })
                  }
                />
              </FormRow>
            )}
            <FormRow controlId="comment" label="Uwagi">
              <FormControlTextarea3
                defaultValue={card?.comment || ''}
                onChange={e =>
                  propertyChange({
                    comment: e.target.value,
                  })
                }
              />
            </FormRow>
            <CardStatusFields
              verified={card?.verified}
              withoutSign={card?.withoutSign}
              propertyChange={propertyChange}
            />
          </div>
        </Tab>
        <Tab eventKey="physical" title="Badanie przedmiotowe #1">
          <RadioButtonWithDesc
            name="Skóra"
            value={card.physicalSkin}
            field={{ physicalSkin: '' }}
            onChange={propertyChange}
          />
          <RadioButtonWithDesc
            name="Czaszka"
            value={card.physicalSkull}
            field={{ physicalSkull: '' }}
            onChange={propertyChange}
          />
          <RadioButtonWithDesc
            name="Węzły chłonne"
            value={card.physicalLymphNodes}
            field={{ physicalLymphNodes: '' }}
            onChange={propertyChange}
          />
          <RadioButtonWithDesc
            name="Nos"
            value={card.physicalNose}
            field={{ physicalNose: '' }}
            onChange={propertyChange}
          />
          <RadioButtonWithDesc
            name="Jama ustno-gardłowa"
            value={card.physicalOropharyngealCavity}
            field={{ physicalOropharyngealCavity: '' }}
            onChange={propertyChange}
          />
          <RadioButtonWithDesc
            name="Szyja"
            value={card.physicalNeck}
            field={{ physicalNeck: '' }}
            onChange={propertyChange}
          />
          <RadioButtonWithDesc
            name="Klatka piersiowa"
            value={card.physicalChest}
            field={{ physicalChest: '' }}
            onChange={propertyChange}
          />
        </Tab>
        <Tab eventKey="physical2" title=".. #2">
          <RadioButtonWithDesc
            name="Płuca"
            value={card.physicalLungs}
            field={{ physicalLungs: '' }}
            onChange={propertyChange}
          />
          <RadioButtonWithDesc
            name="Układ sercowo-naczyniowy"
            value={card.physicalCardiovascularSystem}
            field={{ physicalCardiovascularSystem: '' }}
            onChange={propertyChange}
          />
          <RadioButtonWithDesc
            name="Jama brzuszna"
            value={card?.physicalAbdominalCavity}
            field={{ physicalAbdominalCavity: '' }}
            onChange={propertyChange}
          />
          <RadioButtonWithDesc
            name="Układ moczowo - płciowy"
            value={card?.physicalGenitourinarySystem}
            field={{ physicalGenitourinarySystem: '' }}
            onChange={propertyChange}
          />
          <RadioButtonWithDesc
            name="Układ ruchu"
            value={card?.physicalLocomotorSystem}
            field={{ physicalLocomotorSystem: '' }}
            onChange={propertyChange}
          />
          <RadioButtonWithDesc
            name="Układ nerwowy"
            value={card?.physicalNervousSystem}
            field={{ physicalNervousSystem: '' }}
            onChange={propertyChange}
          />
          <RadioButtonWithDesc
            name="Stan psychiczny"
            value={card.physicalMentalState}
            field={{ physicalMentalState: '' }}
            onChange={propertyChange}
          />
        </Tab>
        <Tab eventKey="physical3" title=".. #3" className="mb-2">
          <div className="d-grid gap-3">
            <PhysicalMeasurementsFields
              card={card}
              propertyChange={propertyChange}
            />
          </div>
        </Tab>
        <Tab eventKey="helpExam" title="Badania pomocnicze">
          <SupportingExaminationView
            examId={exam.id}
            mode={SupportingType.helpExam}
            cardId={id}
            doctorUid={card.psychologistUID || undefined}
            onSupportChange={onSupportChange}
          />
        </Tab>
        <Tab
          eventKey="specialisedConsultations"
          title="Konsultacje specjalistyczne"
        >
          <SupportingExaminationView
            examId={exam.id}
            mode={SupportingType.specialisedConsultation}
            cardId={id}
            doctorUid={card.psychologistUID || undefined}
            onSupportChange={onSupportChange}
          />
        </Tab>
      </Tabs>
    </>
  );
};
